import {apiUrl} from '../../config/net'
import api from '../../tools/api-tools'

/**
 * 续费使用的数据模型
 */
export default class Renewal {
  /**
   * 获取当前需要续费的版本信息
   */
  static getCurrentVersionInfo () {
    return api.get(`${apiUrl}/v0/onlinemall/version1`).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/model/newrenew/index.js